import { PLPSelectedFacetValue } from 'common/types/plp-data';

export type ChangedFacetType = {
  facet: string;
  status: 'added' | 'removed';
};

export function findChangedFacets(
  currentFacets: Record<string, PLPSelectedFacetValue[]>,
  previousFacets: Record<string, PLPSelectedFacetValue[]>,
): ChangedFacetType[] {
  const changedFacets = new Set();
  const oldFacetsMap: Record<string, string> = {};
  const newFacetsMap: Record<string, string> = {};

  Object.values(previousFacets).forEach((values) => {
    if (Array.isArray(values)) {
      values.forEach((value) => {
        oldFacetsMap[value.name] = value.id;
      });
    }
  });

  Object.values(currentFacets).forEach((values) => {
    if (Array.isArray(values)) {
      values.forEach((value) => {
        newFacetsMap[value.name] = value.id;
      });
    }
  });

  Object.keys(oldFacetsMap).forEach((key) => {
    if (!newFacetsMap[key]) {
      changedFacets.add({ facet: key, status: 'removed' });
    } else if (oldFacetsMap[key] !== newFacetsMap[key]) {
      changedFacets.add({ facet: key, status: 'removed' });
    }
  });

  Object.keys(newFacetsMap).forEach((key) => {
    if (!oldFacetsMap[key]) {
      changedFacets.add({ facet: key, status: 'added' });
    }
  });

  return Array.from(changedFacets) as ChangedFacetType[];
}

export function generateChangedFilterText(changedFacets: ChangedFacetType[]) {
  if (changedFacets.length === 0) {
    return '';
  }

  if (changedFacets.length === 1) {
    const { facet, status } = changedFacets[0];

    if (status === 'added') {
      return `${facet} filter added`;
    }

    return `${facet} filter removed`;
  }

  const addedFiltersCount = changedFacets.filter((item) => item.status === 'added')?.length ?? 0;
  const removedFiltersCount = changedFacets.filter((item) => item.status === 'removed')?.length ?? 0;

  if (addedFiltersCount && !removedFiltersCount) {
    return `${addedFiltersCount} filters added`;
  }

  if (!addedFiltersCount && removedFiltersCount) {
    return `${removedFiltersCount} filters removed`;
  }

  if (addedFiltersCount && removedFiltersCount) {
    const addedFiltersText = `${addedFiltersCount} ${addedFiltersCount > 1 ? 'filters' : 'filter'} added`;
    const removedFiltersText = `${removedFiltersCount} ${removedFiltersCount > 1 ? 'filters' : 'filter'} removed`;

    return `${addedFiltersText} and ${removedFiltersText}`;
  }

  return '';
}
